import { each, on } from '../helpers/shortcuts';
import shared from './shared';

export default () => {
  const postContainer = document.querySelector('.c-posts');

  if (postContainer === null) {
    return;
  }

  const titles = postContainer.querySelectorAll('.c-posts__item-title');
  const texts = postContainer.querySelectorAll('.c-posts__text');

  const update = () => {
    // eslint-disable-next-line no-return-assign,no-param-reassign
    each(titles, title => (title.style.minHeight = 0));
    // eslint-disable-next-line no-return-assign,no-param-reassign
    each(texts, text => (text.style.minHeight = 0));

    if (shared.windowWidth < shared.breakpoints.medium) {
      return;
    }

    const itemsPerColumn =
      shared.windowWidth < shared.breakpoints.xlarge ? 2 : 3;

    const maxTextHeight = [];
    const maxTitleHeight = [];

    each(titles, (title, index) => {
      const group = Math.floor(index / itemsPerColumn);
      // eslint-disable-next-line no-param-reassign
      title.dataset.groupId = group.toString();

      if (maxTitleHeight[group] === undefined) {
        maxTitleHeight[group] = 0;
      }
    });

    each(texts, (text, index) => {
      const group = Math.floor(index / itemsPerColumn);
      // eslint-disable-next-line no-param-reassign
      text.dataset.groupId = group.toString();

      if (maxTextHeight[group] === undefined) {
        maxTextHeight[group] = 0;
      }
    });

    window.requestAnimationFrame(() => {
      each(titles, title => {
        maxTitleHeight[title.dataset.groupId] = Math.max(
          parseInt(maxTitleHeight[title.dataset.groupId], 10),
          title.getBoundingClientRect().height,
        );
      });
      each(texts, text => {
        maxTextHeight[text.dataset.groupId] = Math.max(
          parseInt(maxTextHeight[text.dataset.groupId], 10),
          text.getBoundingClientRect().height,
        );
      });

      each(
        titles,
        // eslint-disable-next-line no-return-assign
        title =>
          // eslint-disable-next-line no-param-reassign
          (title.style.minHeight = `${
            maxTitleHeight[title.dataset.groupId]
          }px`),
      );

      each(
        texts,
        // eslint-disable-next-line no-return-assign
        text =>
          // eslint-disable-next-line no-param-reassign
          (text.style.minHeight = `${maxTextHeight[text.dataset.groupId]}px`),
      );
    });
  };

  update();

  on('resize load', window, update);
};



// WEBPACK FOOTER //
// ./src/scripts/modules/posts.js